export default __webpack_public_path__ + "static/Screen Shot 2021-12-01 at 20.05.55-f18806ab2a65be3516588dfb59226864.png";